import React, { useState } from 'react';
import MemberLayout from '../components/MemberLayout';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { formatIDR } from '../lib/format';
import { RiskAlert } from '../components/RiskAlert';

export default function Calculator() {
  const [f, setF] = useState({ balance: 10000000, risk: 1, entry: 2000, sl: 1990, tp: 2020, contract: 100, pip: 1 });
  const set = (k) => (e) => setF({ ...f, [k]: parseFloat(e.target.value) || 0 });

  const riskAmount = f.balance * (f.risk / 100);
  const slDist = Math.abs(f.entry - f.sl);
  const tpDist = Math.abs(f.tp - f.entry);
  const riskPerUnit = slDist * f.contract * f.pip;
  const positionSize = riskPerUnit > 0 ? riskAmount / riskPerUnit : 0;
  const potentialLoss = riskAmount;
  const potentialProfit = positionSize * tpDist * f.contract * f.pip;
  const rr = slDist > 0 ? (tpDist / slDist) : 0;

  const fields = [['Account Balance (IDR)','balance'],['Risk Percentage (%)','risk'],['Entry Price','entry'],['Stop Loss','sl'],['Take Profit','tp'],['Contract Size','contract'],['Pip/Point Value','pip']];

  return (
    <MemberLayout>
      <h1 className="font-display text-2xl sm:text-3xl font-bold">Kalkulator Position Sizing</h1>
      <p className="text-muted-foreground mt-1">Chapter 6 — Money Management & Position Sizing.</p>

      <div className="grid lg:grid-cols-2 gap-6 mt-6">
        <Card className="p-6">
          <h3 className="font-semibold mb-4">Input</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            {fields.map(([label,key]) => (
              <div key={key}><Label className="text-xs">{label}</Label><Input type="number" value={f[key]} onChange={set(key)} className="mt-1.5" data-testid={`calc-${key}-input`} /></div>
            ))}
          </div>
        </Card>
        <Card className="p-6">
          <h3 className="font-semibold mb-4">Hasil</h3>
          <div className="space-y-3 text-sm">
            <Res label="Position Size" value={positionSize.toFixed(2) + ' unit/lot'} />
            <Res label="Potential Loss" value={formatIDR(Math.round(potentialLoss))} danger />
            <Res label="Potential Profit" value={formatIDR(Math.round(potentialProfit))} good />
            <Res label="Risk / Reward" value={`1 : ${rr.toFixed(2)}`} />
            <Res label="Risk Amount" value={formatIDR(Math.round(riskAmount))} />
          </div>
          <div className="mt-5"><RiskAlert compact text="Kalkulator ini merupakan alat edukasi dan bukan rekomendasi investasi." /></div>
        </Card>
      </div>
    </MemberLayout>
  );
}

function Res({ label, value, danger, good }) {
  return (
    <div className="flex items-center justify-between border-b py-2 last:border-0">
      <span className="text-muted-foreground">{label}</span>
      <span className={`font-semibold tabular-nums ${danger ? 'text-red-600' : good ? 'text-emerald-600' : ''}`}>{value}</span>
    </div>
  );
}
